import React from 'react'

export const PasswordStrengthMeter: React.FC<{ password: string }> = ({ password }) => {
  const varietyScore = [
    /[a-z]/.test(password),
    /[A-Z]/.test(password),
    /[0-9]/.test(password),
    /[^A-Za-z0-9]/.test(password)
  ].filter(Boolean).length
  const lengthScore = password.length >= 12 ? 2 : password.length >= 8 ? 1 : 0
  const total = Math.min(4, varietyScore + lengthScore)
  const labels = ['Muito fraca', 'Fraca', 'Média', 'Forte', 'Muito forte']
  const colors = ['bg-red-500', 'bg-orange-500', 'bg-yellow-500', 'bg-green-500', 'bg-emerald-600']
  if (!password) return null
  return (
    <div className="mt-2">
      <div className="h-1.5 w-full bg-gray-200 dark:bg-gray-700 rounded">
        <div className={`h-1.5 rounded ${colors[total]}`} style={{ width: `${(total + 1) * 20}%` }} />
      </div>
      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">{labels[total]}</p>
    </div>
  )
}

export default PasswordStrengthMeter


